import React from 'react'
import { FixedWidthList } from '../components/fixed-width-list'
import { GuestCard } from '../components/guest-card'
import { TileCard } from '../components/tile-card'
import type { StaticGroup, TileLayoutConfig } from '../types'

export const GuestsPresentationList: React.FC<{ guests: StaticGroup[]; cardsPerRow: number; tileLayout?: TileLayoutConfig }> = ({
  guests,
  cardsPerRow,
  tileLayout,
}) => {
  return (
    <FixedWidthList itemsPerRow={cardsPerRow}>
      {guests.map((guest) =>
        tileLayout ? (
          <TileCard
            key={guest._id}
            guest={guest}
            tileLayout={tileLayout}
            navLink={{ page: 'guest', guestId: guest._id }}
            style={{ height: '100%' }}
          />
        ) : (
          <GuestCard key={guest._id} guest={guest} />
        )
      )}
    </FixedWidthList>
  )
}
